'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _components2 = require('components');

var _reactBootstrap = require('react-bootstrap');

var _reduxRouter = require('redux-router');

var _reactRouter = require('react-router');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  PlaylistEditor: {
    displayName: 'PlaylistEditor'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/PlaylistBtn/PlaylistEditor.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { Collapse } from 'react-bootstrap';


var PlaylistEditor = _wrapComponent('PlaylistEditor')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data, authState: state.auth };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ pushState: _reduxRouter.pushState, setUiProps: _info.setUiProps, createDialog: _info.createDialog, updatePlaylist: _docs.updatePlaylist, renamePlaylist: _docs.renamePlaylist, deletePlaylist: _docs.deletePlaylist, setPlaylist: _docs.setPlaylist, dynamicChangePlaylist: _docs.dynamicChangePlaylist, changePlaylistOrder: _docs.changePlaylistOrder, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlaylistEditor, _Component);

  function PlaylistEditor() {
    var _ref;

    (0, _classCallCheck3.default)(this, PlaylistEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PlaylistEditor.__proto__ || (0, _getPrototypeOf2.default)(PlaylistEditor)).call.apply(_ref, [this].concat(args)));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(PlaylistEditor, [{
    key: 'render',
    value: function render() {
      var styles = require('./PlaylistEditor.scss');
      var _props = this.props,
          pushState = _props.pushState,
          playListId = _props.playListId,
          docs = _props.docs,
          renamePlaylist = _props.renamePlaylist,
          updatePlaylist = _props.updatePlaylist,
          deletePlaylist = _props.deletePlaylist,
          changePlaylistOrder = _props.changePlaylistOrder,
          setPlaylist = _props.setPlaylist,
          dynamicChangePlaylist = _props.dynamicChangePlaylist,
          createDialog = _props.createDialog,
          authState = _props.authState; // eslint-disable-line no-shadow

      var playLists = docs.playLists,
          publicPlaylists = docs.publicPlaylists,
          songsByPersonCache = docs.songsByPersonCache,
          savingPlaylist = docs.savingPlaylist;
      var user = authState.user; //eslint-disable-line

      var playList = playLists.find(function (pl) {
        return pl.id === playListId;
      });
      if (!playList) return _react3.default.createElement('div', null); // uzivatel nemá pristup k playlistu (mozna zatim neni prihlasen)

      var publicPlayList = (publicPlaylists || []).find(function (pl) {
        return pl.id === playListId;
      });

      var playListSongs = songsByPersonCache['p:' + playListId]; // playlist v GUI je např 'p:5kbxzevzdvgudtwhrxabcimnp'
      var disabled = user == null || savingPlaylist || user.id !== playList.createdBy;
      var disabledNotBySaving /*zde muze editovat*/ = user == null || user.id !== playList.createdBy;
      var toolClass = 'noPrint' + (disabledNotBySaving ? ' hidden' : '');
      var publicUrl = '/p:' + playListId + '/' + (0, _utils.frindlyName)(playList.name);
      var fullPublicUrl = typeof window !== 'undefined' ? location.protocol + '//' + location.host + publicUrl : 'http://agama2000.com' + publicUrl;

      var getTargetRoute = function getTargetRoute(song) {
        return publicUrl + '/' + song.id + '/' + (0, _utils.frindlyName)(song.name);
      };

      var rows = playListSongs.map(function (song, keyIndex) {
        return _react3.default.createElement(
          'tr',
          { key: keyIndex },
          _react3.default.createElement(
            'td',
            null,
            _react3.default.createElement(
              'i',
              null,
              keyIndex + 1
            ),
            ' ',
            _react3.default.createElement(
              _reactRouter.Link,
              { to: getTargetRoute(song) },
              song.name
            )
          ),
          _react3.default.createElement(
            'td',
            null,
            _react3.default.createElement(
              'span',
              { className: toolClass },
              _react3.default.createElement(_components2.ToolButton, { disabled: disabled, glyphIconName: 'arrow-down', inGroup: true, onClick: function onClick() {
                  return changePlaylistOrder(playListId, song.id, 1);
                } }),
              _react3.default.createElement(_components2.ToolButton, { disabled: disabled, glyphIconName: 'arrow-up', inGroup: true, onClick: function onClick() {
                  return changePlaylistOrder(playListId, song.id, -1);
                } })
            ),
            '\xA0\xA0',
            _react3.default.createElement(
              'span',
              { className: toolClass },
              _react3.default.createElement(_components2.ToolButton, { disabled: disabled, glyphIconName: 'remove', inGroup: true, onClick: function onClick() {
                  return setPlaylist(playListId, song.id, 'remove', true /* onlyOnClient*/);
                } })
            )
          )
        );
      });
      // const addToPlaylistBtn = (<Button bsStyle="primary" onClick={ ()=> this.setState({ open: !this.state.open })}>
      //   <Glyphicon glyph="heart" /> Přidat do playlistu <Glyphicon glyph={this.state.open ? 'triangle-top' : 'triangle-bottom'} />
      //   </Button>);
      var onRenameChange = function onRenameChange(ev) {
        var newName = ev.target.value;
        renamePlaylist(playListId, newName);
      };

      var btnSaveClick = function btnSaveClick() {
        var changes = (0, _extends3.default)({}, playList, { songs: playListSongs.map(function (item) {
            return item.id;
          }) });
        delete changes.createdAt;
        delete changes.createdBy;
        updatePlaylist(changes);
      };

      var changePublicity = function changePublicity(pl) {
        pl.public = pl.public ? false : true;
        pl.visible = pl.public;
      };
      var changeVisibility = function changeVisibility(pl) {
        pl.visible = pl.visible ? false : true;
        if (!pl.public && pl.visible) pl.public = true;
      };

      var pubInfo = !disabledNotBySaving && playList.public ? _react3.default.createElement(
        'div',
        null,
        'Ve\u0159ejn\xE1 adresa tohoto playlistu je ',
        _react3.default.createElement('input', { ref: 'publicUrl', value: fullPublicUrl, readOnly: true })
      ) : null;
      var pubInfo2 = !disabledNotBySaving && playList.public && !playList.visible ? _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'i',
          null,
          'Playlist nebude viditeln\xFD v seznamech ve\u0159ejn\xFDch playlislist\u016F, lze jej otev\u0159\xEDt pouze pomoc\xED adresy (n\xED\u017Ee).'
        )
      ) : null;

      var editingPart = disabledNotBySaving ? null : _react3.default.createElement(
        'div',
        { className: styles.editingPart + ' noPrint' },
        _react3.default.createElement(
          'div',
          { className: styles.chckBoxes },
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement('input', { disabled: disabled, id: 'chb1__' + playList.id, type: 'checkbox', onClick: function onClick() {
                return dynamicChangePlaylist(playList.id, changePublicity);
              }, checked: playList.public }),
            _react3.default.createElement(
              'label',
              { disabled: disabled, htmlFor: 'chb1__' + playList.id },
              'Ve\u0159ejn\xFD playlist '
            )
          ),
          _react3.default.createElement(
            'div',
            { className: styles.visibility },
            _react3.default.createElement('input', { disabled: disabled, id: 'chb2_' + playList.id, type: 'checkbox', onClick: function onClick() {
                return dynamicChangePlaylist(playList.id, changeVisibility);
              }, checked: playList.visible }),
            _react3.default.createElement(
              'label',
              { disabled: disabled, htmlFor: 'chb2_' + playList.id },
              'Viditeln\xFD '
            )
          ),
          pubInfo2,
          pubInfo
        ),
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: disabled, onClick: btnSaveClick },
          savingPlaylist ? _react3.default.createElement(
            'span',
            null,
            _react3.default.createElement(
              'span',
              { className: 'fa fa-refresh fa-spin' },
              ' ',
              ' ',
              ' '
            ),
            ' Ukl\xE1d\xE1m '
          ) : 'Uložit změny'
        ),
        '\xA0\xA0',
        _react3.default.createElement(
          _reactBootstrap.Button,
          { bsStyle: 'primary', disabled: disabled, onClick: function onClick() {
              return createDialog({ msg: 'Playlist bude smazán. Jste si jisti?',
                okBtnText: 'Yes',
                onClick: function onClick() {
                  deletePlaylist(playListId, function () {
                    return pushState(null, '/');
                  });
                },
                onNoClick: function onNoClick() {}, okNoText: 'Cancel'
              });
            } },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'trash' }),
          ' Odstranit cel\xFD playlist'
        )
      );

      var getPublicTitle = function getPublicTitle() {

        var picture = publicPlayList && publicPlayList.createdByObj ? _react3.default.createElement('img', { src: publicPlayList.createdByObj.picture || '/user.png', alt: 'by ' + publicPlayList.createdByObj.visibleName }) : null;
        var desc = publicPlayList && publicPlayList.createdByObj && publicPlayList.createdByObj.visibleName ? _react3.default.createElement(
          'div',
          { className: styles.description },
          'Playlist created by ',
          publicPlayList.createdByObj.visibleName,
          ' ',
          picture
        ) : null;

        return _react3.default.createElement(
          'span',
          { className: styles.publicPlaylistHeader },
          _react3.default.createElement(
            'h1',
            { className: 'noPrint' },
            playList.name,
            ' ',
            _react3.default.createElement(
              'small',
              null,
              '[',
              playListSongs.length,
              ']'
            )
          ),
          desc
        );
      };

      var header = disabledNotBySaving ? getPublicTitle() : _react3.default.createElement(
        'span',
        { className: 'noPrint' },
        'Playlist: ',
        _react3.default.createElement('input', { disabled: disabled, value: playList.name, onChange: onRenameChange }),
        ' ',
        _react3.default.createElement(
          'small',
          null,
          '[',
          playListSongs.length,
          ']'
        )
      );
      return _react3.default.createElement(
        'div',
        { className: styles.PlayListEditor },
        _react3.default.createElement(
          'table',
          { className: 'table table-striped' },
          _react3.default.createElement(
            'thead',
            null,
            _react3.default.createElement(
              'tr',
              null,
              _react3.default.createElement(
                'th',
                null,
                header,
                _react3.default.createElement(
                  'h1',
                  { className: 'onlyPrint' },
                  playList.name
                )
              ),
              _react3.default.createElement(
                'th',
                null,
                '\xA0'
              )
            )
          ),
          _react3.default.createElement(
            'tbody',
            null,
            rows
          )
        ),
        editingPart
      );
    }
  }]);
  return PlaylistEditor;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  authState: _react2.PropTypes.object,
  playListId: _react2.PropTypes.string.isRequired,
  // xid: PropTypes.string.isRequired,
  renamePlaylist: _react2.PropTypes.func.isRequired,
  updatePlaylist: _react2.PropTypes.func.isRequired,
  deletePlaylist: _react2.PropTypes.func.isRequired,
  setPlaylist: _react2.PropTypes.func.isRequired,
  changePlaylistOrder: _react2.PropTypes.func.isRequired,
  dynamicChangePlaylist: _react2.PropTypes.func.isRequired,
  createDialog: _react2.PropTypes.func.isRequired,
  pushState: _react2.PropTypes.func.isRequired
}, _temp)) || _class));

exports.default = PlaylistEditor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaylistBtn/PlaylistEditor.js
// module id = 1188
// module chunks = 0